import isEmpty from "../helpers/is-empty.js";

const scrollSpy = (params) => {

    const ScrollTrigger = params.ScrollTrigger;
    const gsap = params.gsap;
    const elements = Array.from(params.elements);
    const links = Array.from(params.links);
    const navDom = params.nav;
    // const scrollMargin = document.querySelector(".main-header").clientHeight + 1;
    const scrollMargin = 147;
    const negativeSrollMargin = scrollMargin - 10;

    const getSpyLink = (query) => document.querySelector(`[data-id="${query}"]`);

    const setCurrent = (link) => {
        if (!link.hasAttribute("aria-current")) {
            link.setAttribute("aria-current", "true");
            link.parentElement.setAttribute("data-current", "true");
        }
    };

    const removeCurrent = (link) => {
        if (link.hasAttribute("aria-current")) {
            link.removeAttribute("aria-current");
            link.parentElement.removeAttribute("data-current");
        }
    };

    const scrollToSection = (el) => {
      // const offsetY = navDom.getBoundingClientRect().top - 1;
      gsap.to(window, { duration: 1.2, scrollTo: { y: el, offsetY: scrollMargin - 1 }, ease: "power4.out" });
    }

    if (!isEmpty(elements)) {
        elements.forEach((element) => {
            ScrollTrigger.create({
                trigger: element,
                // start: `top top+=${scrollMargin}`,
                start: `top top+=${scrollMargin}`,
                end: `bottom-=1 top+=${scrollMargin}`,
                // markers: true,
                onEnter: () => {
                    const currentLink = getSpyLink(element.id);
                    setCurrent(currentLink);
                },
                onLeave: () => {
                    const currentLink = getSpyLink(element.id);
                    removeCurrent(currentLink);
                },
                onEnterBack: () => {
                    const currentLink = getSpyLink(element.id);
                    setCurrent(currentLink);
                },
                onLeaveBack: () => {
                    const currentLink = getSpyLink(element.id);
                    removeCurrent(currentLink);
                },
            });
        });
    }

    if (!isEmpty(links)) {
        links.forEach((link) => {
            const linkedSection = elements.filter((element) => link.dataset.id === element.id)[0];
            link.addEventListener("click", (event) => {
                event.preventDefault();
                scrollToSection(linkedSection);
                //console.log(negativeSrollMargin - linkedSection.scrollHeight);
            });
        });
    }
};

export { scrollSpy };
